export default __webpack_public_path__ + "assets/images/fcb0aa698dc0dc418f11e44c4aa0998e.png";